import { getRequest } from "../config/axiosConfig";

class DealerService {
    async getDealersById(id: string) {
        return await getRequest(`dealers/${id}`);
    }
    async getDealersSearch(query: string) {
        return await getRequest(`dealers?${query}`);
    }
}

export default DealerService;
